<template>
  <v-bottom-navigation fixed grow color="primary">
    <v-row justify="center" align="center">
      <v-col cols="auto" class="pa-0 mr-3">
        <span class="cart-bottom-label">{{
          cartItems ? cartItems.quantityString : ""
        }}</span>
      </v-col>
      <v-col cols="auto" class="pa-0">
        <a class="cart-bottom-button" href="/cart">
          {{ mess["cart_bottom_button_create_deal"] }}
        </a>
      </v-col>
    </v-row>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: "CartSheet",
  props: {
    cartItems: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.cart-bottom-label {
  font-size: 18px;
  color: #1a1a1a;
}

.cart-bottom-button {
  display: flex;
  padding: 10px 10px;
  background-color: var(--v-primary-base);
  text-decoration: none;
  line-height: 1;
  font-weight: 500;
  border-radius: 6px;
  color: #ffffff;
  border: 2px solid transparent;
  transition: all 250ms;

  &:hover {
    background-color: #ffffff;
    color: var(--v-primary-base);
    border: 2px solid var(--v-primary-base);
  }
}
</style>
